import type { RuleHandler } from "../types";

const checkExcludedEventTypes: RuleHandler = (context, requirement) => {
  const requirementAttributes = requirement.userDrivenAttributes;

  const excludedEventTypes = requirementAttributes?.excludedEventTypes ?? [];

  if (!context.selection.eventType) return true; // if there is no eventType (probably on multi) then we should let it through

  return !excludedEventTypes.includes(context.selection.eventType);
};

export { checkExcludedEventTypes };
